export const HEADER_IMAGES_URLS = {
  sustainabilityunlocked: [
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_1.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_2.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_3.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_4.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_5.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_6.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_7.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_8.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_9.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/sustainabilityunlocked/SU_backgrounds_10.jpg',
  ],
  euromoney: [
    'https://img-cdn.financeunlocked.com/headers-images/euromoney/1.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/euromoney/2.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/euromoney/3.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/euromoney/4.jpg',
  ],
  financeunlocked: [
    'https://img-cdn.financeunlocked.com/headers-images/financeunlocked/1.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/financeunlocked/2.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/financeunlocked/3.jpg',
    'https://img-cdn.financeunlocked.com/headers-images/financeunlocked/4.jpg',
  ],
};

export const HEADER_IMAGE_PRICING =
  'https://img-cdn.financeunlocked.com/headers-images/financeunlocked/6.png?ik-sdk-version=javascript-1.4.3&updatedAt=1666614137671';
export const HEADER_IMAGE_VIDEOS =
  'https://img-cdn.financeunlocked.com/headers-images/7.png?ik-sdk-version=javascript-1.4.3&updatedAt=1666687674552';
export const HEADER_IMAGE_PATHWAYS =
  'https://img-cdn.financeunlocked.com/headers-images/8.png?ik-sdk-version=javascript-1.4.3&updatedAt=1666687674663';
export const HEADER_IMAGE_INSIGHTS =
  'https://img-cdn.financeunlocked.com/headers-images/9.png?ik-sdk-version=javascript-1.4.3&updatedAt=1666687674645';
export const HEADER_IMAGE_GLOSSARY =
  'https://img-cdn.financeunlocked.com/headers-images/2.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1619080601629';

export const VIDEO_MAX_PROGRESS = 90;
export const VIDEO_MIN_PROGRESS = 10;

export const SECONDS_IN_HOUR = 3600;
export const SECONdS_IN_MINUTE = 60;

export enum TenantsRefs {
  Fu = 'financeunlocked',
  Su = 'sustainabilityunlocked',
  Em = 'euromoney',
}

export const WIDE_CATEGORY_LABEL_WIDTH = 160;

export const CURRENCY_CODE_TO_SYMBOL = {
  usd: '$',
  eur: '€',
  gbp: '£',
};

export const COURSE_PAGE_CUSTOM_BLOCKS_URL = '/courses/';
